const mediaItems = [
  {
    title: '某顶流深夜密会全程跟拍画面曝光',
    duration: '06:28',
    views: '892K',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20scene%20with%20abstract%20silhouette%20of%20two%20figures%20and%20paparazzi%20camera%20flashes%2C%20warm%20coral%20red%20and%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20minimalist%20composition%2C%20entertainment%20news%20documentary%20style&width=800&height=450&seq=media-01&orientation=landscape',
    alt: '某顶流深夜密会全程跟拍画面',
  },
  {
    title: '综艺录制现场冲突完整还原：从争执到停录',
    duration: '12:15',
    views: '1.2M',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20television%20studio%20scene%20with%20bright%20stage%20lights%20and%20empty%20seats%2C%20backstage%20chaos%20atmosphere%2C%20warm%20golden%20and%20coral%20tones%2C%20professional%20broadcast%20equipment%2C%20clean%20minimalist%20background&width=800&height=450&seq=media-02&orientation=landscape',
    alt: '综艺录制现场冲突完整还原',
  },
  {
    title: '娱乐圈资本局揭秘：谁在幕后操控你的偶像？',
    duration: '18:42',
    views: '756K',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20illustration%20of%20a%20chess%20board%20with%20spotlight%20pieces%20and%20floating%20dollar%20signs%2C%20warm%20coral%20and%20golden%20gradient%2C%20corporate%20power%20concept%2C%20clean%20simple%20design%2C%20minimalist%20editorial%20style&width=800&height=450&seq=media-03&orientation=landscape',
    alt: '娱乐圈资本局揭秘',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          吃瓜视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          视觉化呈现最精彩的爆料故事
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.alt}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/75 text-background-50 text-xs rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}